import Image from './Image';
import MultilangText from './MultilangText';
function extractFirstURL(str, extesion = '.jpg') {
    const regex = /https:\/\/[^\s]+/;
    const match = str.match(regex);
    if (match && match.length > 0) {
        const firstIndex = match[0].indexOf(extesion);
        if (firstIndex >= 0) {
            return match[0].substring(0, firstIndex + extesion.length);
        }
    }
    return null;
}
export class AccommodationType {
    constructor(data) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "images", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "packageId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "titleFallback", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (!data) {
            this.titleFallback = '';
            return;
        }
        this.id = String(data.room_type_id);
        this.titleFallback =
            typeof data.title === 'string' ? data.title.trim() : '';
        this.packageId = data.package_id || '0';
        try {
            const parsed = JSON.parse(data.room_type_title_langs);
            this.name = new MultilangText(parsed);
            const hasNonBlankLangEntry = parsed &&
                typeof parsed === 'object' &&
                !Array.isArray(parsed) &&
                Object.keys(parsed).some((k) => {
                    const v = parsed[k];
                    return typeof v === 'string' && v.trim().length > 0;
                });
            if (!hasNonBlankLangEntry && this.titleFallback) {
                this.name = new MultilangText(this.titleFallback);
            }
        }
        catch (_a) {
            this.name = new MultilangText(this.titleFallback || ' ');
        }
        const pictureURL = extractFirstURL(data.room_type_photos);
        if (pictureURL) {
            this.images.push(new Image(pictureURL));
        }
    }
    displayName(lang) {
        var _a, _b, _c;
        const localized = (_b = (_a = this.name) === null || _a === void 0 ? void 0 : _a.getText(lang)) === null || _b === void 0 ? void 0 : _b.trim();
        if (localized) {
            return localized;
        }
        const english = (_c = this.name.getText('en')) === null || _c === void 0 ? void 0 : _c.trim();
        if (english) {
            return english;
        }
        return this.titleFallback;
    }
}
